<template>
	<section class="small-12 columns propertyDeets" v-if="property">
		<div class="small-12 nickname border-bottom">
			<h1 class="small-12 text-overflow flex vertical-align animated fadeIn" v-if="!edit_nickname">
				{{ property_clone.attributes.title }}
				<a class="round border medium cMedium editButton flex justify-center vertical-align" @click="editNickname()" v-tooltip="'Edit Nickname'">
					<i class="material-icons-outlined">edit</i>
				</a>
			</h1>
			<div class="small-12 inputContainer flex vertical-align animated fadeIn" style="margin-bottom:10px;" v-else>
				<div class="small-12 large-8">
					<input type="text" placeholder="Give it a new nickname" v-model="property_clone.attributes.title">
				</div>
				<div class="actions small-12 large-4 columns flex vertical-align">
					<a class="round approve" @click="saveNickname()" v-tooltip="'Save'">
						<i class="material-icons-outlined cGreen">check_circle</i>
					</a>
					<a class="round cancel" @click="cancelEditNickname()" v-tooltip="'Cancel'">
						<i class="material-icons-outlined cRed">cancel</i>
					</a>
				</div>
			</div>
			<p class="small-12 flex vertical-align justify-between">
				{{ property.attributes.address.street_1 }} - {{ property.attributes.address.city }}, {{ property.attributes.address.state }} 
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'apartments'">Apartment Complex</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'single_family_home'">Single Family Home</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'duplex'">Duplex</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'condominium'">Condominium(s)</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'hospitality_golf'">Hospitality/Golf</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'industrial'">Industrial</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'land'">Land</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'manufactured_home'">Manufactured Home(s)</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'campground'">Campground</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'mixed_use'">Mixed Use</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'net_leased'">Net Leased</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'retail'">Retail</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'self_storage'">Self Storage</span>
				<span class="badge borderRadius4 bgPrimaryBlue" v-if="property.type == 'seniors_housing'">Seniors Housing</span>
			</p>
		</div>
		<div class="small-12 propertySpecs widget border-bottom">
			<div class="small-12 widgetTitle flex vertical-align">
				<h2 class="small-12 flex vertical-align"> 
					Property Specifications
				</h2>
			</div>
			<ul class="small-12 flex">
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Purchased At
					</p>
					<span class="small-12 flex vertical-align">
						${{property.attributes.purchase.price | noDecimals}}
						<a class="round border medium cMedium editButton flex justify-center vertical-align" @click="editPurchasedAt()" v-tooltip="'Edit Purchased At'">
							<i class="material-icons-outlined">edit</i>
						</a>
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Purchased On
					</p>
					<span class="small-12 flex vertical-align" v-if="property.attributes.purchase.date">
						{{property.attributes.purchase.date | unixToDate}}
					</span>
					<span class="small-12 flex vertical-align" v-else>
						No Date Set
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Price Per Unit
					</p>
					<span class="small-12 flex vertical-align">
						$0.00
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Units
					</p>
					<span class="small-12 flex vertical-align">
						{{property.metrics.units.total}} 
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Square Feet
					</p>
					<span class="small-12 flex vertical-align">
						{{property.attributes.square_feet | noDecimals}}
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Property Type
					</p>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'apartments'"></span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'apartments'">Apartment Complex</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'single_family_home'">Single Family Home</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'duplex'">Duplex</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'condominium'">Condominium(s)</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'hospitality_golf'">Hospitality/Golf</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'industrial'">Industrial</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'land'">Land</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'manufactured_home'">Manufactured Home(s)</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'campground'">Campground</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'mixed_use'">Mixed Use</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'net_leased'">Net Leased</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'retail'">Retail</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'self_storage'">Self Storage</span>
					<span class="small-12 flex vertical-align text-overflow" v-if="property.type == 'seniors_housing'">Seniors Housing</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Lot Size
					</p>
					<span class="small-12 flex vertical-align">
						{{property.attributes.lot_size}} AC
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Number of Stories
					</p>
					<span class="small-12 flex vertical-align">
						{{property.attributes.number_of_stories}}
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Year Built In
					</p>
					<span class="small-12 flex vertical-align" v-if="property.attributes.built_in !== 0">
						{{property.attributes.built_in}}
					</span>
					<span class="small-12 flex vertical-align" v-else>
						-
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Last Renovated In
					</p>
					<span class="small-12 flex vertical-align" v-if="property.attributes.last_renovated !== 0">
						{{property.attributes.last_renovated}}
					</span>
					<span class="small-12 flex vertical-align" v-else>
						-
					</span>
				</li>
				<li class="small-12 large-4">
					<p class="small-12 flex vertical-align">
						Opportunity Zone
					</p>
					<span class="small-12 flex vertical-align" v-if="property.attributes.opportunity_zone == true">
						Yes
					</span>
					<span class="small-12 flex vertical-align" v-else>
						No
					</span>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'

	// Import the components
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyDetails',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			SpinnerMethods,
			BugsnagService,
			AbbreviateNumbersFilters,
			DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			purchase: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			edit_nickname: false,
			nickname: null,
			property: null,
			property_clone: null

		}),


		/*
        ** Do this first
        */

        mounted() {

        	// Bind to the doc
			this.$bind('property', propertiesModel.doc(this.$route.params.id));

        },

        /*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					// Set the clone
					this.property_clone = this.property;

				}

			}

		},

        /*
		**  Set up the methods
		*/

		methods: {

			editNickname: function() {

				// Show the inut
				this.edit_nickname = true;

			},

			cancelEditNickname: function() {

				// Hide the input
				this.edit_nickname = false;

			},

			saveNickname: function() {

				// Show the spinner
				this.showSpinner();

				// Save the nickname
				propertiesModel.doc(this.property.id).update({

					'attributes.title': this.property_clone.attributes.title

				})
				.then(() => {

					// Hide the spinner
					this.hideSpinner();

					// Hide the input
					this.edit_nickname = false;

					// Notify the user
					this.$swal('Success!', 'The nickname of your property has been updated.', 'success');

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Property Details - Save Nickname',
						errorType: 'Firestore Database',
						section: 'Property',
						component: 'PropertyDetails',
						error: error
					});

				});

			},

			editPurchasedAt: function() {

				// Emit the event
				this.$emit('openAddPurchaseMenu', true)

			}

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>	